<template>
  <div :class="['cart-container', { 'has-scrolled': hasScrolled }]" class="w-32 rounded-4 d-flex flex-column position-fixed" style="width: clamp(300px, 400px, 500px); top: 180px;">
    <div class="d-flex position-relative pt-4-5 ps-4-5 pe-4-5 align-items-center">
      <h5 class="fw-bold position-relative text-darkblue z-1">
        JOUW BESTELLING
      </h5>
      <img
        alt="dec"
        src="https://sweetdeliver.nl/wp-content/uploads/2024/09/sweet-dec.svg"
        class="position-absolute end-0 z-0"
        style="width: 40px; top: 35px; right: 130px !important"
      />
    </div>
    <p class="ps-4-5 pe-4-5 mt-2" v-if="orderItems.length === 0">
      Op dit moment heb je nog geen producten in je winkelwagen.
    </p>
    <div v-else class="overflow-auto pe-4-5 ps-4-5" style="max-height: 380px">
      <ul>
        <li
          :class="`d-flex position-relative flex-column mt-4 ${index !== orderItems.length - 1 ? 'border-bottom pb-3' : ''} ${props.editingItem && props.editingItem.uniqueCartId === item.uniqueCartId ? 'opacity-50' : ''}`"
          v-for="(item, index) in orderItems"
          :key="item.uniqueCartId"
        >
          <div class="d-flex align-items-center">
            <img
              :src="item.pickedBox?.acf?.boxpicker_afbeelding?.url ?? item.pickedBox?.images?.[0]?.src"
              alt="Product Image"
              width="100"
              class="cart-item-image rounded-pill"
            />
            <div class="d-flex ms-3 fs-14 w-50 flex-column">
              <p class="fs-14 pb-0">
              {{ item.pickedBox.name }}
            </p>
            <p class="mt-0 pb-0">{{ item.pickedBox?.acf?.ondertitel }}</p>
            <p class="mt-0 pb-0">{{ item.receiver.name }}</p>
            </div>
          </div>
          <div class="d-flex align-items-center mt-3 flex-wrap gap-2">
            <div
              class="bg-blue me-2 d-flex rounded-pill align-items-center justify-content-center"
              v-for="flavour in item.flavours"
              :key="flavour.id"
            >
              <img :src="flavour.image" alt="Flavour Image" width="34" />
            </div>
            <p class="ms-auto fs-14">€{{ (parseFloat(item.pickedBox.price) * (item.quantity ?? 1)).toFixed(2) }}</p>
          </div>
          <!-- Additional Info Toggle -->
          <div class="d-flex align-items-center mt-3">
            <button class="sd-quantity-action min d-flex align-items-center justify-content-center rounded-pill me-2" @click="decreaseQuantity(item)" aria-label="Decrease quantity">
              -
            </button>
            <div class="sd-quantity-indicator">{{ item.quantity ?? 1 }}</div>
            <button @click="increaseQuantity(item)" class="sd-quantity-action plus d-flex align-items-center justify-content-center rounded-pill ms-2" aria-label="Increase quantity">
              +
            </button>
            <div class="ms-auto" role="button" @click="toggleAllInfo(item.uniqueCartId)">
              <p class="fs-14 text-primary" style="text-decoration: underline;">Alle informatie</p>
            </div>
          </div>
          <!-- Additional Information -->
          <div v-if="showAllInfoMap[item.uniqueCartId]" class="mt-3 d-flex flex-column align-items-start">
            <p class="fs-15 pb-0">{{ item.receiver?.name }}</p>
            <p class="fs-15 pb-0">{{ item.receiver?.city }}, {{ item.receiver?.zipcode }}</p>
            <p class="fs-15 pb-0">{{ item.receiver?.street }} {{ item.receiver?.number }}</p>
            <p v-if="item.selectedCard" class="fs-15 pb-0">Gekozen kaart: {{ item.selectedCard.name }}</p>
            <p v-if="item.selectedCard" class="fs-15 pb-0">{{ item.card.text }}</p>
            <p class="fs-15 pb-0">Verzenddatum: {{ new Date(item.sendDate).toLocaleDateString('nl-NL') }}</p> 
          </div>
          <!-- Edit and Remove Buttons -->
          <div class="d-flex align-items-center position-absolute top-0 end-0 sd-btn-flex-col">
            <button
              @click="$emit('edit-item', item)"
              class="icon-btn rounded-pill bg-transparent border-0 me-1"
              style="margin: 0 !important;"
              aria-label="Edit item"
            >
              <!-- Edit SVG -->
              <svg style="width: 20px; height: 20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#152E88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icon-tabler-pencil">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"/>
                <path d="M13.5 6.5l4 4"/>
              </svg>
            </button>
            <button
              @click="removeItem(item.uniqueCartId)"
              class="icon-btn rounded-pill bg-transparent border-0"
              aria-label="Remove item"
            >
              <!-- Remove SVG -->
              <svg style="width: 18px; height: 18px;" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" stroke="#FF4A4A" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 6v-.8c0-1.13 0-1.69-.22-2.11 -.2-.38-.5-.69-.88-.88 -.43-.22-.99-.22-2.11-.22h-1.6c-1.13 0-1.69 0-2.11.21 -.38.19-.69.49-.88.87 -.22.42-.22.98-.22 2.1v.8m2 5.5v5m4-5v5m-11-10.5h18m-2 0v11.2c0 1.68 0 2.52-.33 3.16 -.29.56-.75 1.02-1.32 1.31 -.65.32-1.49.32-3.17.32h-4.4c-1.69 0-2.53 0-3.17-.33 -.57-.29-1.03-.75-1.32-1.32 -.33-.65-.33-1.49-.33-3.17V5.94"/>
              </svg>
            </button>
          </div>
        </li>
      </ul>
    </div>
    <div class="flex-1"></div>
    <div class="ps-4-5 mt-auto pe-4-5 pb-4">
      <div class="border-top d-flex align-items-center justify-content-between border-bottom py-3 mt-auto fw-medium fs-15" style="margin-top: 20px !important;">
        <p class="pb-0">Totaalbedrag</p>
        <p class="pb-0">€{{ totalAmount?.toFixed(2).replace('.', ',') }}</p>
      </div>
      <div class="d-flex mt-4 align-items-center justify-content-between">
        <button
          @click="$emit('checkout')"
          :disabled="loading"
          class="bg-red fs-15 text-light py-2-5 px-4 border-0 rounded-pill ms-auto d-flex align-items-center"
        >
          <span v-if="!loading">Afrekenen</span>
          <span v-else>Toevoegen...</span>
          <div v-if="loading" class="lds-dual-ring ms-2"></div>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref, onMounted, onBeforeUnmount } from "vue";
import { useOrderStore } from "@/stores/orderStore";

const props = defineProps({
  editingItem: Object,
  loading: Boolean,
});
const orderStore = useOrderStore();

const showAllInfoMap = ref({});
const hasScrolled = ref(false);
const orderItems = computed(() => orderStore.items);
const totalAmount = computed(() => orderStore.totalAmount);

const removeItem = (uniqueCartId) => {
  orderStore.removeItem(uniqueCartId);
};

const increaseQuantity = (item) => {
  const newQuantity = (item.quantity || 1) + 1;
  orderStore.updateItemQuantity(item.uniqueCartId, newQuantity);
};

const decreaseQuantity = (item) => {
  if ((item.quantity || 1) > 1) {
    const newQuantity = (item.quantity || 1) - 1;
    orderStore.updateItemQuantity(item.uniqueCartId, newQuantity);
  }
};

const toggleAllInfo = (uniqueCartId) => {
  showAllInfoMap.value[uniqueCartId] = !showAllInfoMap.value[uniqueCartId];
};

const handleScroll = () => {
  hasScrolled.value = window.scrollY >= 100;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
.text-primary {
  color: #152e88 !important;
}

.cart-container {
  min-height: 600px;
  background-color: #fff;
  position: sticky !important;
  transition: width 0.3s ease, right 0.3s ease, transform 0.3s ease;
}

.cart-container.has-scrolled {
  transform: translateY(-58px);
}

.cart-container:after {
  background: 
    linear-gradient(-45deg, #fff0e1 16px, red 16px, blue 16px,  transparent 0), 
    linear-gradient(45deg, #fff0e1 16px, transparent 0);
  background-position: left top;
  background-repeat: repeat-x;
  background-size: 36.5px 32px;
  content: " ";
  display: block;
  height: 32px;
  width: 100%;
  position: relative;
  bottom: 0px;
  left: 0;
}

.rounded-4 {
  border-radius: 15px 15px 0 0 !important;
}

ul {
  list-style: none;
  padding: 0px;
}

.py-2-5 {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
}

.bg-blue {
  background-color: #f7f7f7;
  width: 44px;
  height: 44px;
}

.cart-item-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.fs-14 {
  font-size: 15px;
}

.fs-15 {
  font-size: 15px;
}

.icon-btn:hover {
  background-color: #f1f1f1 !important;
}

.cart-container div ul li .sd-btn-flex-col {
  flex-direction: column;
  
}

/* Quantity Controls Styling */
.d-flex.align-items-center.mt-2 button {
  width: 30px;
  height: 30px;
  padding: 0;
}

.sd-quantity-action.min {
  width: 26px;
  height: 26px;
  border: 1px solid #dddddd;
  background-color: white;
}

.sd-quantity-action.plus {
  width: 26px;
  height: 26px;
  border: 1px solid #dddddd;
  background-color: white;
}

.sd-quantity-indicator {
  width: 30px;
  text-align: center;
  font-size: 14px;
}

/* Loading Spinner Styling */
.lds-dual-ring {
  display: inline-block;
  width: 16px;
  height: 16px;
}
.lds-dual-ring:after {
  content: ' ';
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
